<template>
  <router-view :key="$route.fullPath" />
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

body {
  color: #404040;
  font-family: "Helvetica Neue", Helvetica, STHeiTi, sans-serif;
}

.app-main-content {
  width: 100%;
  font-size: 18px;
  line-height: 1.75;
  word-break: break-word;
  text-align: justify;

  .audio-tips {
    color: #aaa;
    margin-bottom: 3px;
    text-align: left;
  }

  .audio-player {
    width: 100%;
    color: #aaa;
    margin-bottom: 3px;
    height: 54px;
  }

  .video-player {
    width: 100%;
    background: #000;
  }

  hr {
    border: none;
    height: 2px;
    background-color: #eee;
  }

  iframe {
    width: 100%;
    min-height: 200px;
  }

  .content-detail {
    p {
      width: auto;
      margin: 3vw 0;
      box-sizing: border-box;
      font-family: "Microsoft YaHei", arial, "微软雅黑", "Helvetica Neue",
        Helvetica, STHeiTi, sans-serif, freesans, clean;
    }

    img {
      max-width: 100%;
      margin: auto;
      // display: block;
    }

    .vote_question_group {
      img {
        margin: 0;
      }
    }

    .video-js {
      width: 100%;
    }
    //video {
    //object-fit: fill !important;
    // }
  }
}

.zsplus-image {
  width: 100%;
  margin: 0;
  // text-align: center;
}

.zsplus-image img {
  // width: 100%;
  max-width: 100%;
}

.zsplus-image figcaption {
  font-size: 16px;
  color: #999;
}
input.van-field__control::-webkit-input-placeholder {
  color: #666;
}
</style>
